export default {
      id: "icon-error-usage",
      viewBox: "0 0 18 16",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-error",
      toString: function () {
        return this.url;
      }
    }